module.exports = __webpack_public_path__ + "img/center_az.9e947dc2.png";